module.exports = __webpack_public_path__ + "static/media/checkIcon.978cf393.svg";